"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./arrayLikeToArray.js");var e=function(e){if(Array.isArray(e))return r.default(e)};exports.default=e;
